import { Navigate } from 'react-router-dom';
import Constants from '../../utils/Constants';

const Logout = () => {

  return <Navigate to={ Constants.RoutePath.Home } replace={true} />

};

export default Logout;